/* QUICK ADD */

const ISTOCardStock = {
  parseVariantData(scriptElement) {
    if (!scriptElement?.textContent) {
      return null;
    }

    try {
      return JSON.parse(scriptElement.textContent);
    } catch (error) {
      console.warn("ISTOCardStock: invalid variant JSON.", error);
      return null;
    }
  },

  getSwatchVariantData(swatch) {
    return this.parseVariantData(swatch?.querySelector(".product-list-json"));
  },

  isProductAvailable(variantData) {
    return Array.isArray(variantData) && variantData.some((variant) => variant.available);
  },

  getSoldOutBadge(cardWrapper) {
    return cardWrapper.querySelector("[data-card-sold-out-badge]");
  },

  setSoldOutState(cardWrapper, isAvailable) {
    cardWrapper.classList.toggle("no-stock", !isAvailable);

    const soldOutBadge = this.getSoldOutBadge(cardWrapper);
    if (soldOutBadge) {
      soldOutBadge.classList.toggle("hidden", isAvailable);
    }
  },

  updateFromSwatch(cardWrapper, swatch) {
    const variantData = this.getSwatchVariantData(swatch);
    if (!variantData) {
      return null;
    }

    const quickAddContainer = cardWrapper.querySelector(".op__container");
    if (quickAddContainer) {
      updateQuickAddVariants(quickAddContainer, variantData);
    }

    const isAvailable = this.isProductAvailable(variantData);
    this.setSoldOutState(cardWrapper, isAvailable);

    return { variantData, isAvailable };
  },

  restoreInitialState(cardWrapper, initialState) {
    if (!initialState) {
      return;
    }

    const quickAddContainer = cardWrapper.querySelector(".op__container");
    if (quickAddContainer && initialState.variantData) {
      updateQuickAddVariants(quickAddContainer, initialState.variantData);
    }

    this.setSoldOutState(cardWrapper, initialState.isAvailable);
  },
};

function initializeVariantButtons(container) {
  const variantButtons = container.querySelectorAll(".variant-button");
  const selectedVariantInput = container.querySelector("#selectedVariantId");

  variantButtons.forEach((button) => {
    if (button.dataset.variantButtonInit === "true") {
      return;
    }

    button.dataset.variantButtonInit = "true";

    button.addEventListener("click", (e) => {
      let quickAddSheet = document.getElementById("quickAddSheet");
      const selectedOption = button.getAttribute("data-variant-id");
      if (button.disabled) {
        e.preventDefault();
        alert("This variant is unavailable");
        return;
      }

      const loadingSpinner = button.querySelector(".loading__spinner");
      if (loadingSpinner) {
        loadingSpinner.classList.remove("hidden");
      }

      if (selectedVariantInput) {
        selectedVariantInput.value = selectedOption;
        if (quickAddSheet) {
          quickAddSheet.classList.add("hidden");
        }
        document.body.classList.remove("overflow-hidden");
      }
    });
  });
  hideOnAdd();
}

function hideOnAdd() {
  const addButton = document.querySelectorAll(
    "#quickAddSheet .op__container .quick-add__submit"
  );

  addButton.forEach((button) => {
    if (button) {
      if (button.dataset.hideOnAddInit === "true") {
        return;
      }

      button.dataset.hideOnAddInit = "true";

      button.addEventListener("click", () => {
        const quickAddSheet = document.getElementById("quickAddSheet");
        if (quickAddSheet) {
          quickAddSheet.classList.add("hidden");
          document.body.classList.remove("overflow-hidden");
        } else {
          console.warn("quickAddSheet not found");
        }
      });
    } else {
      console.warn("No buttons found");
    }
  });

  if (addButton.length === 0) {
    console.warn("No buttons were added");
  }
}

function updateQuickAddVariants(quickAddContainer, variantData) {
  let variantButtons = Array.from(quickAddContainer.querySelectorAll(".variant-button"));
  if (variantButtons.length === 0) {
    return;
  }

  const sortedVariantData = window.ISTOVariantSort
    ? window.ISTOVariantSort.sortByText(variantData, (variant) => variant.title)
    : variantData;

  if (variantButtons.length !== sortedVariantData.length) {
    // The selected color has a different number of sizes than the color
    // currently rendered on the card: rebuild the buttons instead of
    // reusing stale ones, otherwise sizes from the previous color stay on screen.
    const template = variantButtons[0];
    const parent = template.parentElement;

    variantButtons.slice(1).forEach((button) => button.remove());

    variantButtons = sortedVariantData.map((_, index) => {
      if (index === 0) return template;
      const clone = template.cloneNode(true);
      clone.removeAttribute("data-variant-button-init");
      parent.appendChild(clone);
      return clone;
    });
  }

  variantButtons.forEach((button, index) => {
    const variant = sortedVariantData[index];

    button.setAttribute("data-variant-id", variant.id);
    button.setAttribute("aria-disabled", !variant.available);

    if (variant.available) {
      button.classList.remove("disabled");
    } else {
      button.classList.add("disabled");
    }

    const span = button.querySelector("span");
    if (span) {
      span.textContent = variant.title;
    }
  });
  initializeVariantButtons(quickAddContainer);
}

function getCardMediaContainer(cardWrapper) {
  const mediaLink = cardWrapper.querySelector(".card__media > a");
  if (mediaLink) {
    const swiperSlide = mediaLink.querySelector(
      "scx-product-image-swiper .swiper-slide"
    );
    if (swiperSlide) {
      return (
        swiperSlide.querySelector("._media") ||
        swiperSlide.querySelector(".media:not(.nmedia)")
      );
    }

    return (
      mediaLink.querySelector("._media") ||
      mediaLink.querySelector(".media:not(.nmedia)")
    );
  }

  return cardWrapper.querySelector(".card__inner .media:not(.nmedia)");
}

function variantImages() {
  document
    .querySelectorAll(".product-card-wrapper:not([data-variant-images-init])")
    .forEach((cardWrapper) => {
      const principalMediaContainer = getCardMediaContainer(cardWrapper);
      const variationSwatches = cardWrapper.querySelectorAll(
        ".product_variant__swatch"
      );

      if (!principalMediaContainer || variationSwatches.length === 0) {
        return;
      }

      cardWrapper.setAttribute("data-variant-images-init", "true");
      const originalImage = principalMediaContainer.innerHTML;
      const originalHasHoverEffect = principalMediaContainer.classList.contains(
        "media--hover-effect"
      );
      const initialActiveSwatch = cardWrapper.querySelector(
        ".product_variant__swatch.active_swatch"
      );
      const initialStockState = {
        variantData: ISTOCardStock.getSwatchVariantData(initialActiveSwatch),
        isAvailable: !cardWrapper.classList.contains("no-stock"),
      };
      let isImageChanged = false;

      function resetImage() {
        principalMediaContainer.innerHTML = originalImage;
        principalMediaContainer.classList.toggle(
          "media--hover-effect",
          originalHasHoverEffect
        );
        isImageChanged = false;

        variationSwatches.forEach((swatch) => {
          swatch.classList.remove("active", "active_swatch");
        });
        if (initialActiveSwatch) {
          initialActiveSwatch.classList.add("active", "active_swatch");
        }

        ISTOCardStock.restoreInitialState(cardWrapper, initialStockState);
      }

      variationSwatches.forEach((swatch) => {
        swatch.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();

          variationSwatches.forEach((item) => {
            item.classList.remove("active");
          });
          swatch.classList.add("active");

            const newImage = swatch.querySelector(
              ".image-cards img:not(.secondary-image)"
            );
            if (newImage) {
              const newSecondaryImage = swatch.querySelector(
                ".image-cards img.secondary-image"
              );
              principalMediaContainer.innerHTML = "";
              principalMediaContainer.appendChild(newImage.cloneNode(true));
              if (newSecondaryImage) {
                principalMediaContainer.appendChild(
                  newSecondaryImage.cloneNode(true)
                );
              }
              principalMediaContainer.classList.toggle(
                "media--hover-effect",
                Boolean(newSecondaryImage)
              );
              isImageChanged = true;
            }

          const container = cardWrapper.querySelector(".op__container");
          if (container) {
            const scriptData = swatch.querySelector(".product-list-json");
            if (scriptData) {
              const variantData = JSON.parse(scriptData.textContent);
              updateQuickAddVariants(container, variantData);
            }
          }
        });
      });

      cardWrapper.addEventListener("click", function (event) {
        if (
          !event.target.closest(".product_variant__swatch") &&
          !event.target.closest(".quick-add")
        ) {
          resetImage();
        }
      });
    });
}

function observeContainerForVariantImages(container, datasetKey) {
  if (!container || container.dataset[datasetKey] === "true") {
    return;
  }

  container.dataset[datasetKey] = "true";
  const observer = new MutationObserver(() => {
    variantImages();
  });
  observer.observe(container, { childList: true, subtree: true });
}

function observeProductGridForVariantImages() {
  observeContainerForVariantImages(
    document.getElementById("ProductGridContainer"),
    "variantImagesObserved"
  );

  document.querySelectorAll("product-recommendations").forEach((recommendations) => {
    observeContainerForVariantImages(recommendations, "variantImagesObserved");
  });
}

function handleMobileSheet(button) {
  const parentContainer = button.closest(".quick-add__container");
  const dropdown = parentContainer.querySelector(
    ".quick-add__dropdown"
  ).innerHTML;

  let quickAddSheet = document.getElementById("quickAddSheet");
  if (!quickAddSheet) {
    quickAddSheet = document.createElement("div");
    quickAddSheet.id = "quickAddSheet";
    quickAddSheet.className = "quick-add__sheet hidden";

    quickAddSheet.innerHTML = `
        <div class="quick-add__sheet-content">
          <div class="quick-add__container"></div>
        </div>
      `;

    document.body.appendChild(quickAddSheet);

    quickAddSheet.addEventListener("click", (event) => {
      if (event.target === quickAddSheet) {
        quickAddSheet.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      }
    });

    const detailsCloseButton = quickAddSheet.querySelector(".close-mobile-btn");

    if (detailsCloseButton) {
      detailsCloseButton.addEventListener("click", () => {
        quickAddSheet.classList.add("hidden");
        document.body.classList.remove("overflow-hidden");
      });
    }
  }

  const sheetContainer = quickAddSheet.querySelector(".quick-add__container");
  sheetContainer.innerHTML = dropdown;
  initializeVariantButtons(sheetContainer);

  quickAddSheet.classList.remove("hidden");
  document.body.classList.add("overflow-hidden");
}

function handleDesktopOverlay(button) {
  const parentContainer = button.closest(".quick-add__container");
  const dropdown = parentContainer.querySelector(".quick-add__dropdown");

  // Toggle the active class
  const isActive = dropdown.classList.contains("active");
  dropdown.classList.toggle("active", !isActive);

  // Update the aria-expanded attribute
  button.setAttribute("aria-expanded", !isActive);
}

function handleQuickAdd() {
  const quickAddButtons = document.querySelectorAll(".quick-add__submit");

  quickAddButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const isMobile = window.matchMedia("(max-width: 990px)").matches;

      if (isMobile) {
        handleMobileSheet(button);
      } else {
        handleDesktopOverlay(button);
      }
    });
  });

  // Close other dropdowns when one is clicked (optional)
  document.addEventListener("click", (event) => {
    const clickedButton = event.target.closest(".quick-add__submit");

    if (!window.matchMedia("(max-width: 990px)").matches) {
      document
        .querySelectorAll(".quick-add__dropdown.active")
        .forEach((dropdown) => {
          const parentContainer = dropdown.closest(".quick-add__container");
          const button = parentContainer.querySelector(".quick-add__submit");

          // If the clicked element is not the current button, close the dropdown
          if (clickedButton !== button) {
            dropdown.classList.remove("active");
            button.setAttribute("aria-expanded", "false");
          }
        });
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  variantImages();
  observeProductGridForVariantImages();
  handleQuickAdd();
  document.querySelectorAll(".quick-add__container").forEach((container) => {
    initializeVariantButtons(container);
  });
  hideOnAdd();
});

window.variantImages = variantImages;

document.querySelector(".load-more-button")?.addEventListener("click", () => {
  const productGrid = document.getElementById("product-grid");
  const observer = new MutationObserver((mutationList, observerInstance) => {
    const newItems = mutationList.some(
      (mutation) => mutation.addedNodes.length > 0
    );

    if (newItems) {
      variantImages();
    }
  });

  observer.observe(productGrid, {
    childList: true,
    subtree: false,
  });
  /* observerInstance.disconnect(); */
});
